import { captureException } from '@sentry/nextjs';
import { HeaderProps, FooterProps } from '@spotify-internal/masthead-react';

export const getMasthead = async (
  market: string,
): Promise<{
  header?: HeaderProps;
  footer?: FooterProps;
}> => {
  const MASTHEAD_API = 'https://www.spotify.com/api/masthead/v1/masthead';
  const queryParams = new URLSearchParams({ market });

  try {
    const res = await fetch(`${MASTHEAD_API}?${queryParams}`, { credentials: 'include' });

    if (!res.ok) {
      throw new Error(`Failed to fetch masthead data: ${res.status}`);
    }

    return await res.json();
  } catch (e) {
    captureException(e);
    return {};
  }
};
